module.exports = __webpack_public_path__ + "static/media/api_webhook.323939a5.svg";